import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/** @jsx jsx */

import { jsx } from '@emotion/core';
import { GRAB_AREA_LINE_SELECTOR, GRAB_AREA_SELECTOR } from '../../common/constants';
import { grabAreaCSS, lineCSS } from './styles';

var grabAreaLineSelector = _defineProperty({}, GRAB_AREA_LINE_SELECTOR, true);

var grabAreaSelector = _defineProperty({}, GRAB_AREA_SELECTOR, true); // TODO: Consider allowing this to be controlled using arrow keys


var GrabArea = function GrabArea(_ref) {
  var testId = _ref.testId,
      isLeftSidebarCollapsed = _ref.isLeftSidebarCollapsed,
      rest = _objectWithoutProperties(_ref, ["testId", "isLeftSidebarCollapsed"]);

  return jsx("button", _extends({}, grabAreaSelector, {
    "data-testid": testId,
    type: "button",
    css: grabAreaCSS(isLeftSidebarCollapsed)
  }, rest), jsx("span", _extends({
    css: lineCSS(isLeftSidebarCollapsed)
  }, grabAreaLineSelector)));
};

export default GrabArea;